import { render, staticRenderFns } from "./LeaseRequestCard.vue?vue&type=template&id=700af927"
import script from "./LeaseRequestCard.vue?vue&type=script&lang=ts"
export * from "./LeaseRequestCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports